import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const colDefs = [
    {
        field: 'transDate',
        headerName: 'Trans Date',
        sortable: false,
        filter: false,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'transTime',
        headerName: 'Trans Time',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => {

            if ( params.value === 0 ) return ( <span>{params.value}</span> );
            return ( <span>{formatGivenDate( params.value, 'HH:mm:ss' )}</span> );

        }
    },
    {
        field: 'buildWeek',
        headerName: 'Build Week',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'constraintType',
        headerName: 'Constraint Type',
        sortable: true,
        // filter: true,
        width: 85
    },
    {
        field: 'constraintKey',
        headerName: 'Constraint Key',
        sortable: true,
        // filter: true,
        width: 120,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=${params.data.constraintType.trim()}&constraintkey=${params.value.trim()}&week=${formatGivenDate( params.data.buildWeek, 'YYYY-MM-DD' )}`}>{params.value}</Link> );

        }
    },
    {
        field: 'startWeek',
        headerName: 'Start Week',
        sortable: true,
        // filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'allocatedQty',
        headerName: 'Allocated Qty',
        sortable: true,
        // filter: true,
        width: 90
        // valueGetter: function ( params ) {

        //     return showInfinity(params.data.quantity.maximumQty) ;

        // }
    },
    {
        field: 'constraintQty',
        headerName: 'Constraint Qty',
        sortable: true,
        // filter: true,
        width: 90
    },
    {
        field: 'activityType',
        headerName: 'Activity Type',
        sortable: true,
        // filter: true,
        width: 100
    }, {
        field: 'drc',
        headerName: 'DRC',
        sortable: true,
        // filter: true,
        width: 70
    },
    {
        field: 'rdd',
        headerName: 'RDD',
        sortable: true,
        // filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MM-DD' );
            return ( <span>{dt}</span> );

        }
    }
];

const ConstraintViolationsByOrderTable = props => (

    <section className="atp-search-result-panel constraint-violations-by-order-result-panel ">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
                headerHeight={47}
            />
        </div>

    </section>
);

ConstraintViolationsByOrderTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default ConstraintViolationsByOrderTable;
